import { render, staticRenderFns } from "./reserve-pc.vue?vue&type=template&id=f9485ca8&scoped=true&"
import script from "./reserve-pc.vue?vue&type=script&lang=js&"
export * from "./reserve-pc.vue?vue&type=script&lang=js&"
import style0 from "./reserve-pc.vue?vue&type=style&index=0&id=f9485ca8&scoped=true&lang=css&"
import style1 from "./reserve-pc.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9485ca8",
  null
  
)

export default component.exports